<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component"/>
      </transition>
    </router-view>
  </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import util from "@/util/util";

export default {
  name: 'App',
  components: {},
  beforeMount() {
    var token = localStorage.getItem("token");
    if (token === null || token === undefined) {
      var uuidv = uuidv4();
      localStorage.setItem("token", uuidv);
      util.$post("/home/visitAddress", {type: "00"})
    }
  },
  computed: {},
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1440px;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: auto !important;
  background-color: #525761;
  background-image: linear-gradient(to bottom right, #525761, #320e41);
}
</style>
